import { useUserContext } from 'context/UserContext';
import { useFormikContext } from 'formik';
import React, { useState } from 'react';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.css';
import InputBase, { inputClass } from './InputBase';

// CSS Modules, react-datepicker-cssmodules.css
// import 'react-datepicker/dist/react-datepicker-cssmodules.css';

interface Props {
  name: string;
  label: string;
  helperText: string | null;
  /**
   * Days that should be enabled in the picker, e.g. [1, 2, 3, 4, 5, 6, 0] for Monday to Sunday
   */
  availableDays: number[];
  disabled?: boolean;
}

const InputDate: React.FC<Props> = ({
  name,
  label,
  helperText,
  availableDays,
  disabled,
}) => {
  const { language } = useUserContext();
  const { setFieldValue, getFieldProps, setFieldTouched, getFieldMeta } =
    useFormikContext<{
      [key: string]: string;
    }>();
  const handleChange = (date: Date) => {
    setFieldTouched(name);
    setFieldValue(name, date.toDateString());
  };
  const { value } = getFieldProps(name);
  const { error } = getFieldMeta(name);
  const filterDate = (date: Date): boolean => {
    const day = date.getDay();
    return availableDays.includes(day);
  };

  return (
    <InputBase name={name} label={label} helperText={helperText}>
      <DatePicker
        selected={value ? new Date(value) : null}
        placeholderText={
          language === 'EN' ? 'Select a date' : 'Selecciona una fecha'
        }
        onChange={handleChange}
        disabled={disabled}
        filterDate={filterDate}
        className={inputClass(!!error, false)}
        minDate={new Date()}
        maxDate={new Date(new Date().setDate(new Date().getDate() + 365))}
      />
    </InputBase>
  );
};

export default InputDate;
